import React from "react";
import {
  Linkedin,
  Globe,
  Mail,
  Phone,
  MapPin,
  ArrowUp,
  Cpu,
} from "lucide-react";

import Logo from "../../Images/Focus Logo.jpg"; // change path if needed

import FIT from "../../Images/FIT.png";
import FNI from "../../Images/FNI.png";

const CorporateFooter = () => {
  const scrollToTop = () =>
    window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="bg-white pt-24 pb-12 px-6 border-t border-slate-100">

      <div className="max-w-7xl mx-auto">

        {/* ================= TOP ================= */}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16 mb-20">


          {/* BRAND */}

          <div className="space-y-6">

            {/* LOGO */}

            <img
              src={Logo}
              alt="Focus NDT Group Logo"
              className="h-12 object-contain"
              loading="lazy"
            />

            <p className="text-sm text-slate-500 leading-relaxed">
              Focus NDT Group provides industrial inspection,
              non-destructive testing (NDT), PAUT, TOFD,
              welding inspection, offshore inspection,
              and digital inspection software solutions
              for global oil & gas, shipyard, fabrication,
              refinery, and heavy engineering industries.
            </p>

<div className="flex flex-col gap-4">

  {/* FIT */}

  <div className="flex items-center gap-4 bg-slate-50 rounded-lg p-4 min-h-[70px]">

    <img
      src={FIT}
      alt="Focus Inspection Technology"
      className="h-14 w-auto object-contain"
      loading="lazy"
    />

    <div className="flex flex-col text-sm">

      <span className="font-bold text-slate-800">
        Focus Inspection Technology
      </span>

      <a
        href="https://focusinspectiontechnology.com"
        target="_blank"
        rel="noopener noreferrer"
        className="text-orange-600 font-semibold hover:underline"
      >
        Visit Website →
      </a>

    </div>

  </div>



  {/* FNI GROUP */}

  <div className="bg-slate-50 rounded-lg p-4 flex flex-col gap-3">

    {/* FNI title clickable */}

    <a
      href="https://focusin360.com"
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center gap-4"
    >
      <img
        src={FNI}
        alt="Focus NDT Innovations"
        className="h-12 w-auto object-contain"
        loading="lazy"
      />

      <span className="font-bold text-base text-slate-800 hover:text-orange-600">
        Focus NDT Innovations
      </span>
    </a>


    {/* FocusIn360 */}

    <div className="flex items-center justify-between text-sm pl-2">

      <span className="text-slate-700">
        FocusIn360 Software
      </span>

      <a
        href="https://focusin360.com"
        target="_blank"
        rel="noopener noreferrer"
        className="text-orange-600 font-semibold hover:underline"
      >
        Visit →
      </a>

    </div>


    {/* EvalNDT */}

    <div className="flex items-center justify-between text-sm pl-2">

      <span className="text-slate-700">
        EvalNDT Software
      </span>

      <a
        href="https://evalndt.com"
        target="_blank"
        rel="noopener noreferrer"
        className="text-orange-600 font-semibold hover:underline"
      >
        Visit →
      </a>

    </div>

  </div>

</div>

          </div>



          {/* COMPANY */}

          <div>

            <h4 className="text-[11px] font-black uppercase tracking-[0.3em] mb-6 text-slate-900">
              Company
            </h4>

            <ul className="space-y-3 text-sm text-slate-500">

              <li>
                <a href="#about" className="hover:text-orange-600">
                  About Group
                </a>
              </li>

              <li>
                <a href="#leadership" className="hover:text-orange-600">
                  Leadership
                </a>
              </li>

              <li>
                <a href="#timeline" className="hover:text-orange-600">
                  Timeline
                </a>
              </li>

              <li>
                <a href="#contact" className="hover:text-orange-600">
                  Contact
                </a>
              </li>

            </ul>

          </div>



          {/* SERVICES */}

          <div>

            <h4 className="text-[11px] font-black uppercase tracking-[0.3em] mb-6 text-slate-900">
              Services
            </h4>

            <ul className="space-y-3 text-sm text-slate-500">

              <li>
                <a
                  href="https://focusinspectiontechnology.com/services"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-orange-600"
                >
                  PAUT Inspection
                </a>
              </li>

              <li>
                <a
                  href="https://focusinspectiontechnology.com/services"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-orange-600"
                >
                  TOFD Inspection
                </a>
              </li>

              <li>
                <a
                  href="https://focusinspectiontechnology.com/services"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-orange-600"
                >
                  Ultrasonic Testing
                </a>
              </li>

              <li>
                <a
                  href="https://focusinspectiontechnology.com/services"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-orange-600"
                >
                  Welding Inspection
                </a>
              </li>

              <li>
                <a
                  href="https://focusinspectiontechnology.com/services"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-orange-600"
                >
                  Offshore Inspection
                </a>
              </li>

            </ul>

          </div>



          {/* CONTACT */}

          <div>

            <h4 className="text-[11px] font-black uppercase tracking-[0.3em] mb-6 text-slate-900">
              Contact
            </h4>

            <ul className="space-y-4 text-sm text-slate-500">

              <li className="flex gap-2">
                <MapPin size={16} />
                India • Middle East • Offshore
              </li>

              {/* <li className="flex gap-2">
                <Phone size={16} />
                +91 XXXXX XXXXX
              </li> */}

              <li className="flex gap-2">
                <Mail size={16} />
                focusndtgroup@gmail.com
              </li>

            </ul>

          </div>

        </div>



        {/* INDUSTRIES */}

        <div className="border-t border-slate-100 pt-10 pb-10 text-center">

          <p className="text-xs text-slate-400 uppercase tracking-widest">

            Oil & Gas • Offshore • Shipyard • Fabrication • Refinery • Pipeline • Power Plant • Heavy Engineering

          </p>

        </div>



        {/* BOTTOM */}

        <div className="pt-8 border-t border-slate-100 flex flex-col md:flex-row justify-between items-center gap-6">

          <p className="text-[10px] font-bold text-slate-400 tracking-[0.3em] uppercase">
            © 2026 Focus NDT Group • Industrial Inspection & NDT Services
          </p>

          <button
            onClick={scrollToTop}
            className="flex items-center gap-3 text-[10px] font-black uppercase tracking-[0.3em] text-slate-900 hover:text-orange-600"
          >
            Back to Top

            <div className="p-2 bg-slate-900 text-white rounded-full">
              <ArrowUp size={14} />
            </div>

          </button>

        </div>

      </div>

    </footer>
  );
};

export default CorporateFooter;